import { useAuthStore } from '@revelio/auth';
import { isLocalhost } from '@revelio/core';
import { KibanaLogger } from '@revelio/iso-utility';

import packageJson from '../../../package.json';
import { environment } from '../../environments/environment';
import { getOpenReplaySessionUrl } from '../../hooks/open-replay';

export const kibanaLogger = new KibanaLogger({
  source: 'REVELIO_DASHBOARD',
  dashMetaRoot: environment.DASH_META_API,
  version: packageJson.version,
  getAuthInfo: () => ({
    dashMetaCsrfToken: useAuthStore.getState().dashMetaCsrfToken,
    ory: useAuthStore.getState().ory,
  }),
  sendLogs: !isLocalhost(),
  getSessionUrl: getOpenReplaySessionUrl,
});
